// Sidebar dimensions
export const SIDEBAR_WIDTH = "14rem"; // 224px
export const SIDEBAR_WIDTH_MOBILE = "18rem"; // 288px
export const SIDEBAR_WIDTH_ICON = "3.15rem"; // 56px

// Keyboard shortcut for toggling sidebar
export const SIDEBAR_KEYBOARD_SHORTCUT = "b";

// Cookie name for persisting sidebar state
export const SIDEBAR_COOKIE_NAME = "sidebar:state";
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 days
